export default "__VITE_ASSET__DFKzmUcJ__"